export default "__VITE_ASSET__BtCcAG8s__"